import { sharedColors } from '../../utils/Style';

export interface SlidingBanner {
  id: number;
  title: string;
  body: string;
  color: string;
  sortOrder: number;
  linkUrl: string;
  isActive: boolean;
  speed: number;
  repeat: number;
  createdAt: Date;
  updatedAt: Date;
}

export const getEmptySlidingBanner = (): SlidingBanner => ({
  id: 0,
  title: '',
  body: '',
  color: sharedColors.primary,
  sortOrder: 10,
  linkUrl: '',
  isActive: false,
  speed: 100,
  repeat: 1,
  createdAt: new Date(),
  updatedAt: new Date(),
});

export const slidingBannerFromResponse = (
  responseData: any,
): SlidingBanner => ({
  id: responseData.id,
  title: responseData.title,
  body: responseData.body,
  color: responseData.color,
  sortOrder: responseData.sort_order,
  linkUrl: responseData.link_url,
  isActive: responseData.is_active,
  speed: responseData.speed,
  repeat: responseData.repeat,
  createdAt: new Date(responseData.created_at),
  updatedAt: new Date(responseData.updated_at),
});

export const slidingBannerToUpsertRequest = (
  slidingBanner: SlidingBanner,
): any => ({
  title: slidingBanner.title,
  body: slidingBanner.body,
  color: slidingBanner.color,
  sort_order: slidingBanner.sortOrder,
  link_url: slidingBanner.linkUrl,
  is_active: slidingBanner.isActive,
  speed: slidingBanner.speed,
  repeat: slidingBanner.repeat,
});
